module.exports = __webpack_public_path__ + "img/icon1.e9aa0d05.svg";